export const SET_SITE = 'SITE::SET_SITE';
export const UPDATE_SITE = 'SITE::UPDATE_SITE';
export const REMOVE_SITE = 'SITE::REMOVE_SITE';

export type State = {
    site: any;
    updateSite: boolean
}

export type SiteAction = 
    | { type: typeof SET_SITE; payload: string; }
    | { type: typeof REMOVE_SITE; payload: string }
